class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.variantChangeHandler = this.variantChangeHandler.bind(this);
    this.updatePriceSync = this.updatePriceSync.bind(this);
  }

  connectedCallback() {
    const variantInput = document.querySelector('.product-variant-id');

    if (variantInput) {
      variantInput.addEventListener('change', this.variantChangeHandler);
    }

    this.initPriceSync();
  }

  disconnectedCallback() {
    const variantInput = document.querySelector('.product-variant-id');

    if (variantInput) {
      variantInput.removeEventListener('change', this.variantChangeHandler);
    }

    this.removePriceSync();
  }

  variantChangeHandler(e) {
    fetch(`${this.dataset.productUrl}?variant=${e.target.value}&section_id=${this.dataset.sectionId}`)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newWidget = doc.querySelector('.esa__subscription-container');

        if (newWidget) {
          this.style.display = 'block';

          const selling_plan_inputs = this.querySelectorAll('input[name="selling_plan"]');
          selling_plan_inputs.forEach(element => {
            element.disabled = false;
          });

          const subscription_container = this.querySelector('.esa__subscription-container');

          if (subscription_container) {
            const saveBadge = newWidget.querySelector('.esa__save-badge');
            const benefitWrap = newWidget.querySelector('.esa__subscription-benefits');

            // update input attrs also
            const newInputs = newWidget.querySelectorAll('input[name="selling_plan"]');
            const currentInputs = this.querySelectorAll('input[name="selling_plan"]');

            currentInputs.forEach((input, index) => {
              if (newInputs[index]) {
                input.value = newInputs[index].value;
                input.dataset.price = newInputs[index].dataset.price;
                input.dataset.comparePrice = newInputs[index].dataset.comparePrice;
              }
            });

            if (saveBadge && this.querySelector('.esa__save-badge')) {
              this.querySelector('.esa__save-badge').textContent = saveBadge.textContent;
            }

            if (benefitWrap && this.querySelector('.esa__subscription-benefits')) {
              this.querySelector('.esa__subscription-benefits').innerHTML = benefitWrap.innerHTML;
            }

            this.querySelector('.esa__subscription-box .esa__price').innerHTML =
              newWidget.querySelector('.esa__subscription-box .esa__price').innerHTML;

            this.querySelector('.esa__one-time-box .esa__price').innerHTML =
              newWidget.querySelector('.esa__one-time-box .esa__price').innerHTML;

          } else {
            this.innerHTML = doc.querySelector('#esa__subscription-widget').innerHTML;
          }

          this.initPriceSync();

        } else {
          this.style.display = 'none';

          const selling_plan_inputs = this.querySelectorAll('input[name="selling_plan"]');
          selling_plan_inputs.forEach(element => {
            element.disabled = true;
          });
        }
      });
  }

  initPriceSync() {
    this.radios = this.querySelectorAll('input[name="selling_plan"]');

    if (!this.radios.length) return;

    this.radios.forEach(radio => {
      radio.removeEventListener('change', this.updatePriceSync);
      radio.addEventListener('change', this.updatePriceSync);
    });

    this.updatePriceSync();
  }

  removePriceSync() {
    if (!this.radios) return;

    this.radios.forEach(radio => {
      radio.removeEventListener('change', this.updatePriceSync);
    });
  }

  updatePriceSync() {
    const checked = this.querySelector('input[name="selling_plan"]:checked');
    if (!checked) return;
    
    const salePrice = checked.dataset.price || '';
    const comparePrice = checked.dataset.comparePrice || '';
    
    const priceContainer = document.querySelector(`#price-${this.dataset.sectionId}`);
    
    if (!priceContainer) return;
    
    const regularPriceEl = priceContainer.querySelector('.price__regular .price-item--regular');
    const salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
    const comparePriceEl = priceContainer.querySelector('.price__sale s.price-item--regular');
    
    if (!regularPriceEl || !salePriceEl) return;
    
    if (comparePrice && comparePrice !== salePrice) {
      salePriceEl.textContent = salePrice;
      regularPriceEl.textContent = salePrice;
      if (comparePriceEl) comparePriceEl.textContent = comparePrice;
    }
  }
}

customElements.define('subscription-widget', SubscriptionWidget);